import React from "react";
import {Redirect, Route} from "react-router-dom";
import {connect} from "react-redux";
// import MotionPage from "../modules/custom/MotionPage";

const PublicRoute = ({ component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={props =>
                rest.isLoggedIn === false ? (
                    <Component {...props} {...rest} />
                ) : (
                    <Redirect
                        to={{ pathname: "/", state: { from: props.location } }}
                    />
                )
            }
        />
    );
};

const mapStateToProps = (state) => ({
    isLoggedIn: state.Auth.isLoggedIn
})

export default connect(mapStateToProps)(PublicRoute)
